module.exports = __webpack_public_path__ + "static/media/photo-left-last.637924c6.png";